import { IonRouterOutlet } from '@ionic/react';
import React from 'react';
import { Redirect, Route } from 'react-router';

import PrivateRoute from '@components/PrivateRoute';
import RoutePath from '@custom-types/RoutePath';
import { LoginType } from '@hooks/useLogin';
import ForgotPassword from '@pages/Auth/ForgotPassword';
import ForgotPasswordSuccess from '@pages/Auth/ForgotPasswordSuccess';
import Companies from '@pages/Companies';
import Language from '@pages/Language';
import LeadCaptureEvents from '@pages/LeadCapture/Events';
import ManageMobi from '@pages/ManageMobi';
import { generateRoute } from '@services/navigation-service';
import { CommonRoutes } from 'src/CommonRoutes';

import Login from './Auth/Login';
import VerifyEmailLink from './Auth/VerifyEmailLink';
import Edit from './Edit';
import useIsAuthenticated from './hooks/useIsAuthenticated';
import LeadTabs from './Tabs';

const AuthRoutes = () => (
  <IonRouterOutlet ionPage id="lead-capture-auth">
    <Route exact path={generateRoute(RoutePath.Login)}>
      <Login />
    </Route>
    <Route
      path={generateRoute(RoutePath.ForgotPassword)}
      render={props => <ForgotPassword type={LoginType.WithPassword} {...props} />}
    />
    <Route
      path={generateRoute(RoutePath.ForgotPasswordSuccess)}
      component={ForgotPasswordSuccess}
    />
    <Route exact path={generateRoute(RoutePath.LoginWithEmailLink)}>
      <VerifyEmailLink />
    </Route>
  </IonRouterOutlet>
);

export default () => {
  useIsAuthenticated();

  return (
    <IonRouterOutlet>
      <Route exact path={generateRoute()}>
        <Redirect
          to={{
            pathname: generateRoute(RoutePath.Login),
          }}
        />
      </Route>
      <Route path={generateRoute(RoutePath.Language)}>
        <Language />
      </Route>
      <Route path={generateRoute(RoutePath.Login)}>
        <AuthRoutes />
      </Route>
      <Route path={generateRoute(RoutePath.ManageMobi)}>
        <ManageMobi />
      </Route>
      <Route exact path={generateRoute(RoutePath.Lead)}>
        <Redirect
          to={{
            pathname: generateRoute(RoutePath.LeadHome),
          }}
        />
      </Route>
      <Route path={generateRoute([RoutePath.OpenApp, RoutePath.UpdateRequired])}>
        <CommonRoutes />
      </Route>
      <IonRouterOutlet ionPage id="lead-capture-app">
        <PrivateRoute
          path={generateRoute([RoutePath.LeadHome, RoutePath.LeadAdd, RoutePath.LeadList])}
          exact
        >
          <LeadTabs />
        </PrivateRoute>
        <PrivateRoute path={generateRoute(RoutePath.LeadEdit)} exact>
          <Edit />
        </PrivateRoute>
        <PrivateRoute path={generateRoute(RoutePath.EventList)} exact>
          <LeadCaptureEvents />
        </PrivateRoute>
        <PrivateRoute path={generateRoute(RoutePath.CompanyList)} exact>
          <Companies />
        </PrivateRoute>
      </IonRouterOutlet>
    </IonRouterOutlet>
  );
};
